import { useState } from 'react';
import { NavLink, useLocation } from 'react-router-dom';

import Frame from '../layout/Frame';
import { Button, Input, Popup } from '../components';
import { AppRoute, ButtonType } from '../types/enums';

import mailIcon from '../components/Input/envelope-regular.svg';
import { isValidEmail } from '../utils/common';
import { sendForgotPAsswordEmail } from '../requests/requests';

const ForgotPassword = () => {
  const { state: { email: initialEmail } = { email: '' } } = useLocation();

  const [email, setEmail] = useState(initialEmail);
  const [emailError, setEmailError] = useState(false);
  const [isSent, setIsSent] = useState(false);

  const onSubmit = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();

    setEmailError(false);

    if (isValidEmail(email)) {
      sendForgotPAsswordEmail(email);
      setIsSent(true);
    } else {
      setEmailError(true);
    }
  };

  return (
    <Frame>
      <Popup show title="Forgot password" permanent>
        {isSent ? (
          <div>
            <p>
              If the email is associated with an existing user, we'll send an email with
              instructions on how to reset your password.
            </p>
            <NavLink className="color-orange" to={AppRoute.LOGIN}>
              Login
            </NavLink>
          </div>
        ) : (
          <div>
            <p>
              Did you forget your password? No problem, we'll send you a reset link. Just type in
              your registration email.
            </p>
            <form onSubmit={onSubmit}>
              <Input
                id="email"
                label="E-mail:"
                value={email}
                setValue={setEmail}
                placeholder="youremail@gmail.com"
                icon={mailIcon}
                error={emailError ? 'Error: must be a valid email address!' : ''}
              />
              <Button type={ButtonType.PRIMARY} fullWidth isSubmit>
                Reset password
              </Button>
            </form>
          </div>
        )}
      </Popup>
    </Frame>
  );
};

export default ForgotPassword;
